import gql from 'graphql-tag';

export const QUERY_OFFLINE_PAYMENT_ORDER_RECEIVABLES_LIST = gql`
  query listOfflinePaymentOrderReceivables(
    $citySlug: NonEmptyString
    $countrySlug: NonEmptyString
    $invoiceNumber: NonEmptyString
    $landlordSlug: NonEmptyString
    $moveInDateStart: String
    $moveInDateEnd: String
    $moveOutDateStart: String
    $moveOutDateEnd: String
    $orderReferenceId: NonEmptyString
    $propertySlug: NonEmptyString
    $receivableStatus: [OrderReceivableStatus]
    $pageNumber: Int = 1
    $pageSize: Int = 10
    $bookingJourneys: [ListingPlan]
    $commissionTriggerPoint: CommissionTriggerPointType
  ) {
    listOfflinePaymentOrderReceivables(
      citySlug: $citySlug
      countrySlug: $countrySlug
      invoiceNumber: $invoiceNumber
      landlordSlug: $landlordSlug
      moveInDateStart: $moveInDateStart
      moveInDateEnd: $moveInDateEnd
      moveOutDateStart: $moveOutDateStart
      moveOutDateEnd: $moveOutDateEnd
      orderReferenceId: $orderReferenceId
      propertySlug: $propertySlug
      receivableStatus: $receivableStatus
      pageNumber: $pageNumber
      pageSize: $pageSize
      bookingJourneys: $bookingJourneys
      commissionTriggerPoint: $commissionTriggerPoint
    ) {
      edges {
        id
        referenceId
        currency
        status
        invoiceNumber
        invoicedAt
        landlord {
          name
          slug
        }
        property {
          bookingJourney
          name
          listings {
            edges {
              node {
                id
              }
            }
          }
        }
        orderReceivableProcesses {
          currentStatus
          note
        }
        order {
          id
          currency
          moveInDate
          moveOutDate
          listingMinPrice
          listingId
          listingSalesPrice
          propertyId
          propertyName
          unitTypeId
          unitTypeName
          totalRental
          completedAt
          createdAt
          referenceId
          paidAt
          bookingJourney
          commissionTriggerPoint
          student {
            passportFirstName
            passportMiddleName
            passportLastName
            emailAddress
          }
          city {
            name
            slug
            country {
              name
              slug
            }
          }
        }
        commission {
          commissionTierType
          commissionTierValue
          currency
          totalPrice
        }
      }
      totalCount
    }
  }
`;

export const QUERY_LEAD_GENERATION_DETAIL_BY_ID = gql`
  query CMS_QueryOrderReceivable($id: ID!) {
    getOrderReceivable(id: $id) {
      id
      referenceId
      createdAt
      updatedAt
      status
      currency
      invoiceNumber
      landlord {
        name
        slug
      }
      commission {
        id
        currency
        commissionTierType
        commissionTierValue
        bonusCommissionTierType
        bonusCommissionTierValue
        totalPrice
        creditNoteAmount
        creditNoteNumber
        data {
          commission {
            commissionData {
              capped
              tier {
                type
                name
                id
                category
                effectiveFrom
                effectiveTo
              }
            }
          }
        }
      }
      order {
        id
        createdAt
        completedAt
        paidAt
        listingId
        currency
        moveInDate
        moveOutDate
        totalRental
        referenceId
        listingMinPrice
        listingSalesPrice
        propertyId
        propertyName
        unitTypeId
        unitTypeName
        bookingJourney
        commissionTriggerPoint
        stage
        receivables {
          orderReceivableProcesses {
            updatedAt
            modifierName
            currentInvoiceNumber
            currentStatus
            note
          }
        }
        student {
          passportFirstName
          passportMiddleName
          passportLastName
          emailAddress
          phoneNumber
        }
        property {
          name
          bookingJourney
          listings {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_RECONCILIATION_STATUS = gql`
  mutation updateOrderReceivable($input: UpdateOrderReceivableInput) {
    updateOrderReceivable(input: $input) {
      orderReceivable {
        id
      }
    }
  }
`;

export const MUTATION_UPDATE_RECONCILIATION_RENT = gql`
  mutation updateOrderRent($input: UpdateOrderRentInput!) {
    updateOrderRent(input: $input) {
      order {
        id
      }
    }
  }
`;

export const MUTATION_UPDATE_COMMISSION_CREDIT_NOTE = gql`
  mutation updateOrderCommissionCreditNote($input: UpdateOrderCommissionCreditNoteInput!) {
    updateOrderCommissionCreditNote(input: $input) {
      orderCommission {
        id
      }
    }
  }
`;
